import * as React from 'react';
import { Box, Typography, Button } from '@mui/material';
import CustomCommentSection from '../CustomCommentSection';

/**
 * Props pour le composant CustomMessageStep
 */
interface CustomMessageStepProps {
    customMessage: string;
    isProcessing: boolean;
    suggestionCount: number;
    onSave: (message: string) => void;
    onCancel: () => void;
    onPrev: () => void;
}

/**
 * Composant pour l'étape de saisie du message personnalisé
 */
export const CustomMessageStep: React.FunctionComponent<CustomMessageStepProps> = function ({
    customMessage,
    isProcessing,
    suggestionCount,
    onSave,
    onCancel,
    onPrev,
}) {
    return (
        <Box sx={{ width: '500px', maxWidth: '90vw' }}>
            <Typography
                variant="h6"
                sx={{ p: 2, pb: 0 }}
            >
                Message personnalisé pour {suggestionCount > 1 ? 'les' : 'le'} rappel
                {suggestionCount > 1 ? 's' : ''}
            </Typography>
            <CustomCommentSection
                comment={customMessage}
                isSaving={isProcessing}
                onSave={onSave}
                onClose={onCancel}
                cancelButtonLabel="Ignorer cette étape"
                confirmButtonLabel="Créer les rappels"
                noCancelButton
            />

            <Box
                display="flex"
                justifyContent="flex-start"
                sx={{ p: 2, pt: 0 }}
            >
                <Button
                    variant="text"
                    onClick={onPrev}
                    disabled={isProcessing}
                >
                    Retour à la sélection
                </Button>
            </Box>
        </Box>
    );
};
